import { postUsersByUserIdEditMutation } from "@aura-frontend/omnibus-az-client";
import { useMutation } from "@tanstack/react-query";
import { Button, Icons, toast, useConfirmStore } from "@win-reality/react-ui";

type DeleteUserFromAccountButtonProps = {
  accountId: string;
  isAccountOwner: boolean;
  orgId: string;
  onDelete: () => void;
};

export const DeleteUserFromAccountButton = ({
  accountId,
  isAccountOwner,
  orgId,
  onDelete,
}: DeleteUserFromAccountButtonProps) => {
  const deleteUser = useMutation({
    ...postUsersByUserIdEditMutation(),
    onError: () => {
      toast("You don't have permissions to delete this user", {
        variant: "error",
      });
    },
  });

  const confirm = useConfirmStore((state) => state.confirm);

  const handleDelete = async () => {
    const confirmed = await confirm({
      title: "Confirm User Deletion",
      description: isAccountOwner
        ? "Deleting the Account Owner will allow inviting a new one."
        : "Are you sure you want to remove this user from the account?",
      confirmText: "Delete User",
      confirmButtonVariant: "destructive",
    });

    if (confirmed) {
      useConfirmStore.setState({ isPending: true });

      await deleteUser.mutateAsync(
        {
          body: {
            orgRoles: [],
            orgId: orgId,
          },
          path: {
            user_id: accountId,
          },
        },

        {
          onSettled: () => {
            useConfirmStore.setState({ isOpen: false, isPending: false });
          },
          onSuccess: () => {
            onDelete();
          },
        },
      );
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => handleDelete()}
      className="text-blue"
    >
      <Icons.Trash />
    </Button>
  );
};
